var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v("Currency Deprecate"),
            ]),
          ]),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("r-currency-deprecate-mode", {
                        attrs: { model: _vm.mode },
                        on: {
                          "update:model": function ($event) {
                            _vm.mode = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pt-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    {
                      model: {
                        value: _vm.panels,
                        callback: function ($$v) {
                          _vm.panels = $$v
                        },
                        expression: "panels",
                      },
                    },
                    [
                      _c("r-guard-panel", {
                        attrs: {
                          hidden: _vm.mode.id === 0,
                          model: _vm.model.guard,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "guard", $event)
                          },
                        },
                      }),
                      _c("r-reward-bunch-panel", {
                        attrs: {
                          hidden: _vm.mode.id === 0,
                          model: _vm.model.rewardBunch,
                          title: "Rewards",
                          label: "Bunch:",
                          percent: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "rewardBunch", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.startResize.apply(null, arguments)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }